<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <ModuleShell :title="t('views.home.welcomeBack')" :icon="Info">
      <template #action>
        <button @click.stop="emit('close')" class="p-1 transition-opacity opacity-50 hover:opacity-100">
          <X class="w-5 h-5 text-[var(--color-text)]" />
        </button>
      </template>

      <!-- Text Content -->
      <div class="flex-1 text-center">
        <p class="text-[var(--color-text)]">{{ t("views.home.appDescription") }}</p>
        <p v-if="canInstall">{{ t('views.home.installText') }}
          <a class="text-blue-400 hover:text-blue-500" @click.prevent="installPWA">
            {{ t('views.home.appInstall') }}
          </a>.
        </p>
      </div>

  </ModuleShell>
</template>

<script setup>
  import { useI18n } from 'vue-i18n'
  import { useRouter } from 'vue-router'
  import { Info, X } from 'lucide-vue-next'
  import ModuleShell from '@/components/ui/layout/ModuleShell.vue'
  import { usePWAInstall } from "@/utils/home/usePWAInstall"

  const { t } = useI18n()
  const router = useRouter()
  const emit = defineEmits(['close'])
  const { canInstall, installPWA } = usePWAInstall()

</script>